import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-exchange-cert-dialog',
  templateUrl: './exchange-cert-dialog.component.html',
  styleUrls: ['./exchange-cert-dialog.component.scss']
})
export class ExchangeCertDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ExchangeCertDialogComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }
}
